import { endOfDay, startOfDay } from 'date-fns';
import { DateRange } from './date-range';

export function getDefaultDateRange(): DateRange {
  return {
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
  };
}
